
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pickleball/city/[citySlug]/courts",
      function () {
        return require("private-next-pages/pickleball/city/[citySlug]/courts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pickleball/city/[citySlug]/courts"])
      });
    }
  